<div class="lmo-frac-fcpo-manage">
  <section class="purchase-order-list">
    <ng-container *ngFor="let meshWithFcpos of meshesWithFcpos$ | async">
      <div class="group-header">
        <span>{{ meshWithFcpos.type }} Mesh</span>
      </div>
      <div class="mesh-group">
        <a
          class="row"
          *ngFor="let fcpo of meshWithFcpos.fcpos; trackBy: trackById"
          [routerLink]="['./', fcpo.id]"
          routerLinkActive="active-row"
        >
          <div class="cell middle">
            <div class="highlight">
              {{ fcpo.purchaseOrder.mineName }}
              <br />
              {{ fcpo.purchaseOrder.name }}
            </div>
          </div>
        </a>
      </div>
    </ng-container>
  </section>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>
